
import {
  computed, defineComponent, PropType, toRefs,
} from 'vue-demi';
import './select.scss';

export default defineComponent({
  name: 'adm-select',
  emits: ['update:modelValue', 'blur'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    size: {
      type: String as PropType<'small'|'normal'>,
      default: 'normal',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array as PropType<
        Array<{ label: string; value: string; disabled?: boolean }>
        >,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    helperText: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      disabled, dense,
      size,
      helperText,
      error,
    } = toRefs(props);
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(nextValue) {
        emit('update:modelValue', nextValue);
      },
    });

    const classes = computed(() => [
      'adm-select',
      `adm-select--${size.value}`,
      {
        'adm-select--with-value': !!value.value,
        'adm-select--disabled': disabled.value,
        'adm-select--dense': dense.value,
        'adm-select--error': !!error.value,
      },
    ]);

    const descriptionText = computed(() => error.value || helperText.value || '');

    return {
      classes,
      descriptionText,
      value,
    };
  },
});
